export default "__VITE_ASSET__CNqhz3eG__"